module.exports = __webpack_public_path__ + "img/17.7c875b17.webp";